import React from 'react';

import useStoreTranslation from 'hooks/useStoreTranslation';
import { htmlT } from 'utils/generic';

import FilterButton from '../FilterButton';
import { Container, MessageContainer, Message } from './styles';

interface Props {
  name: string;
}

const MessageBox = ({ name }: Props) => {
  const { t } = useStoreTranslation();

  return (
    <Container>
      <MessageContainer>
        <Message>{htmlT(t, 'dashboard.messageName', { name })}</Message>
      </MessageContainer>
      <FilterButton />
    </Container>
  );
};

export default MessageBox;
